import React from "react";

import LogoMin from "../../assets/images/Лого/nume2.png";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer_wrapper">
          <div className="footer_left">
            <div
              className="footer_logo"
              style={{
                background: `url(${LogoMin}) no-repeat`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                width: "100%",
                height: "200px"
              }}
            />

            <div className="footer_social">
              <span>
                <a href="https://www.facebook.com/groups/1735631426741689/"><i className="fab fa-facebook-f" /></a>
              </span>
              <span>
                <i className="fab fa-vk" />
              </span>
              <span>
                <i className="fab fa-twitter" />
              </span>
              <span>
                <i className="fab fa-google" />
              </span>
            </div>
          </div>
          <div className="footer_right">
            <div className="footer_top">
              <span>
                <i className="fas fa-phone" />
              </span>
              <div className="number_wrapper">
                <span className="number">+373 69 90 27 86</span>
              </div>
            </div>

            <span className="location">
              <i className="fas fa-map-marker-alt" /> Кишинёв, Алба-Юлия
            </span>
            <span className="footer_nav">
              <li><a href='/'>Главная</a></li>
              <li><a href='/products/Продукты'>Товар</a></li>
              <li><a href='/contacts'>Контакты</a></li>
            </span>
          </div>
        </div>

        <div className="foooter_copyright">
          <p>&copy; 2019 Планета Рыбака. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


//#e7f7f6